<div class="flex h-full min-h-0 overflow-hidden bg-[#fcf8f1] font-['Inter',system-ui,sans-serif]">
  <aside class="hidden h-full min-h-0 w-[14.5rem] shrink-0 flex-col overflow-hidden bg-[#0b1a16] lg:flex">
    <!-- Brand -->
    <div class="shrink-0 px-4 pb-3 pt-5">
      <div class="flex items-center gap-2.5">
        <span class="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-[0.35rem] bg-[#f3f5f4] font-['Playfair_Display',serif] text-sm font-semibold text-[#0b1a16]">
          M
        </span>
        <div class="min-w-0">
          <p class="truncate font-['Playfair_Display',serif] text-[0.875rem] font-medium leading-tight text-[#f3f5f4]">
            Maison Verde
          </p>
          <p class="text-[0.625rem] text-[#6b7c74]">Admin · Lisboa</p>
        </div>
      </div>
    </div>

    <!-- Nav -->
    <nav class="admin-sidebar__nav min-h-0 flex-1 overflow-y-auto px-3 pb-3" aria-label="Admin navigation">
      @for (section of navSections(); track section.title) {
        <div class="mb-4 first:mt-0">
          <p class="mb-2 text-[0.6875rem] font-semibold uppercase tracking-[0.1em] text-[#6b7c74]">
            {{ section.title }}
          </p>
          <div class="flex flex-col gap-0.5">
            @for (link of section.links; track link.label) {
              <div>
                @if (link.route) {
                  <a
                    [routerLink]="link.route"
                    routerLinkActive="admin-sidebar__link--active"
                    [routerLinkActiveOptions]="{ exact: link.route === '/admin/dashboard' }"
                    class="admin-sidebar__link flex items-center justify-between rounded-lg border-l-[3px] border-transparent py-2 pl-1.5 pr-2 text-[0.8125rem] text-[#9fb0a8] no-underline transition hover:bg-[#1e2f28]/70 hover:text-[#e8eeeb]"
                  >
                    <span class="flex min-w-0 items-center gap-2.5">
                      <span class="admin-sidebar__icon shrink-0 text-[#8fa098]" [innerHTML]="navIcon(link.icon)"></span>
                      <span class="truncate">{{ link.label }}</span>
                    </span>
                    @if (link.badge !== undefined) {
                      <span class="inline-flex h-[1.125rem] min-w-[1.125rem] shrink-0 items-center justify-center rounded-full bg-[#162620] px-1 text-[0.5625rem] font-medium text-[#b8c4be]">
                        {{ link.badge }}
                      </span>
                    }
                  </a>
                } @else {
                  <span class="flex items-center justify-between rounded-lg py-2 pl-1.5 pr-2 text-[0.8125rem] text-[#8fa098]">
                    <span class="flex min-w-0 items-center gap-2.5">
                      <span class="shrink-0 text-[#7d8f86]" [innerHTML]="navIcon(link.icon)"></span>
                      <span class="truncate">{{ link.label }}</span>
                    </span>
                    @if (link.badge !== undefined) {
                      <span class="inline-flex h-[1.125rem] min-w-[1.125rem] shrink-0 items-center justify-center rounded-full bg-[#162620] px-1 text-[0.5625rem] font-medium text-[#b8c4be]">
                        {{ link.badge }}
                      </span>
                    }
                  </span>
                }
              </div>
            }
          </div>
        </div>
      }
    </nav>

    <!-- Profile -->
    <div id="admin-profile-menu" class="relative shrink-0 border-t border-[#1e2f28] px-3 py-3">
      <button
        type="button"
        class="admin-sidebar__profile flex w-full items-center gap-2.5 rounded-xl px-2.5 py-2 text-left transition"
        [attr.aria-expanded]="profileMenuOpen()"
        aria-haspopup="menu"
        aria-controls="admin-profile-dropdown"
        (click)="toggleProfileMenu()"
      >
        <span class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#c9b896] text-[0.6875rem] font-semibold text-[#3d3428]">
          {{ userInitials }}
        </span>
        <span class="min-w-0 flex-1">
          <span class="block truncate text-[0.8125rem] font-medium leading-tight text-[#f3f5f4]">{{ userName }}</span>
          <span class="block truncate text-[0.6875rem] text-[#6b7c74]">{{ userRole }}</span>
        </span>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.75"
          class="h-4 w-4 shrink-0 text-[#6b7c74] transition"
          [class.rotate-180]="profileMenuOpen()"
          aria-hidden="true"
        >
          <path d="m18 15-6-6-6 6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      @if (profileMenuOpen()) {
      <div
        id="admin-profile-dropdown"
        class="admin-sidebar__dropdown absolute bottom-full left-3 right-3 z-10 mb-2 overflow-hidden rounded-xl border border-[#1e2f28] bg-[#122019] py-1 shadow-[0_8px_30px_rgba(0,0,0,0.35)]"
        role="menu"
      >
        <button
          type="button"
          class="admin-sidebar__menu-item flex w-full items-center gap-2.5 px-3 py-2.5 text-[0.8125rem] text-[#9fb0a8] transition disabled:opacity-50"
          role="menuitem"
          [disabled]="isLoggingOut"
          (click)="onLogoutClick()"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="h-4 w-4 shrink-0" aria-hidden="true">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>{{ isLoggingOut ? 'Signing out…' : 'Sign out' }}</span>
        </button>
      </div>
      }
    </div>
  </aside>

  <main class="min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-contain">
    <router-outlet></router-outlet>
  </main>
</div>
